import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AccessContent from './components/AccessContent';

export default function AccessPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="bg-auto bg-repeat" style={{ backgroundImage: 'url(https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/72c694f9-1409-463b-96d1-bc011dfd125d_compressed_14.webp)' }}>
        <AccessContent />

        {/* CTA */}
        <section className="py-16 px-4 md:px-6 bg-primary-500">
          <div className="max-w-2xl mx-auto text-center">
            <p className="text-sm text-background-50/70 mb-3 tracking-wider reveal-child">
              {t('access_cta_text')}
            </p>
            <Link
              to="/reservation"
              className="inline-flex items-center gap-3 px-10 py-4 bg-background-50 text-primary-600 text-sm tracking-widest rounded-md hover:bg-accent-100 transition-all duration-300 font-label whitespace-nowrap reveal-child reveal-delay-1"
            >
              <i className="ri-calendar-check-line text-lg" />
              {t('access_reservation')}
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}